import HistorySetting from '@di-shared/features/history/setting/HistorySetting';

interface HistorySettingPageProps {
  vin: string;
}

export default function HistorySettingPage({vin}: HistorySettingPageProps) {
  return <HistorySetting vin={vin} />;
}
